import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { diffChars } from 'diff';
import { $createParagraphNode, $getRoot } from 'lexical';
import { type RefObject, useEffect } from 'react';
import type { ChangeSet } from '@/types/common.ts';
import { $createDiffNode } from './diff-node.tsx';

type Props = {
	changeSet: ChangeSet;
	isRemoveActive?: boolean;
	isAddedActive?: boolean;
	skipOnChange: RefObject<boolean>;
};

export function HighlightDifferencePlugin({
	changeSet,
	skipOnChange,
	isRemoveActive = false,
	isAddedActive = false
}: Props) {
	const [editor] = useLexicalComposerContext();

	useEffect(() => {
		skipOnChange.current = true;

		if (!changeSet.previous || !changeSet.current) {
			return;
		}
		editor.update(() => {
			const root = $getRoot();
			root.clear();

			const diffs = diffChars(changeSet.previous, changeSet.current);
			const paragraph = $createParagraphNode();

			diffs.forEach(({ value, added, removed }) => {
				if (!value) {
					return;
				}

				const shouldShow =
					(!added && !removed) ||
					(added && isAddedActive) ||
					(removed && isRemoveActive);

				if (shouldShow) {
					paragraph.append($createDiffNode(value, added, removed));
				}
			});

			root.append(paragraph);
		});
	}, [
		changeSet.current,
		changeSet.previous,
		editor,
		isAddedActive,
		isRemoveActive,
		skipOnChange
	]);

	return null;
}
